import { render, staticRenderFns } from "./gamblers-gold.vue?vue&type=template&id=6d32ad18&scoped=true&"
import script from "./gamblers-gold.vue?vue&type=script&lang=js&"
export * from "./gamblers-gold.vue?vue&type=script&lang=js&"
import style0 from "./gamblers-gold.vue?vue&type=style&index=0&id=6d32ad18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d32ad18",
  null
  
)

export default component.exports